
import { defineComponent, onMounted } from "vue";
import { useVersao } from "../../modules/versao";

/**
 * Aviso fixo de versão nova do front, com o botão de recarregar. A recarga automática (troca de
 * tela, volta para a aba sem modal aberto) está em modules/versao.ts e no router; este aviso
 * cobre quem fica parado numa tela com um formulário aberto.
 */
export default defineComponent({
  setup() {
    const { novaVersao, recarregar, iniciarVerificacaoVersao } = useVersao();
    onMounted(() => iniciarVerificacaoVersao());
    return { novaVersao, recarregar: () => recarregar() };
  }
});
